import type { Availability, Driver } from './types';

export const STATUSES: { value: Availability, label: string, color: string }[] = [
    { value: 'AVAILABLE', label: 'Available', color: '#16a34a' },
    { value: 'AVAILABLE_LOCALLY', label: 'Local only', color: '#d97706' },
    { value: 'AVAILABLE_ON', label: 'Later', color: '#2563eb' },
    { value: 'NOT_AVAILABLE', label: 'Unavailable', color: '#dc2626' },
];

export const PARKED_COLOR = '#94a3b8';

export const statusOf = (driver: Driver) => STATUSES.find((status) => status.value === driver.available);
export const statusColor = (driver: Driver) => statusOf(driver)?.color || PARKED_COLOR;

// "1071 Agustin Gonzalez" -> "1071": what fits next to a pin when zoomed out.
export const shortLabel = (truckNumber: string) => truckNumber.trim().split(/\s+/)[0] || '';
